import type { PartnersContent } from "../types";

export const partners: PartnersContent = {
  title: "Infrastrukturpartnere",
  lead:
    "UCloud AI kører på national suveræn infrastruktur: bæredygtige " +
    "datacentre bygget i samarbejde med Danfoss og HPE, med mulighed " +
    "for at skalere til AI-supercomputeren Gefion.",
  gridAriaLabel: "Infrastrukturpartnere og samarbejdspartnere",
  partnerNames: {
    deic: "DeiC",
    danfoss: "Danfoss",
    hpe: "HPE",
    dcai: "DCAI",
    dfm: "Danish Foundation Models",
  },
  partnerRoles: {
    deic: "National e-infrastruktur",
    danfoss: "Bæredygtig teknologi",
    hpe: "Enterprise-teknologi / HPC",
    dcai: "AI-supercomputeren Gefion",
    dfm: "Danske åbne modeller",
  },
  partnerHrefs: {
    deic: "https://deic.dk/",
    danfoss: "https://www.danfoss.com/dk/",
    hpe: "https://www.hpe.com/dk_da/",
    dcai: "https://www.dcai.dk/",
    dfm: "https://www.foundationmodels.dk/",
  },
};
